const submit_rate = (id, input, resolve, reject) => {
  var data = JSON.stringify(input);
  
  var xhr = new XMLHttpRequest();
  xhr.withCredentials = true;
  const url = document.getElementById('url').value;
  xhr.addEventListener("readystatechange", function () {
    try {
      const result = JSON.parse(this.responseText);
      if (result.ok) {
        resolve();
      } else {
        reject();
      }
    } catch {
      reject();
    }
  });
  

  xhr.open("POST", `${url}/api/rates/send`);
  xhr.setRequestHeader("content-type", "application/json");
  xhr.setRequestHeader("user-id", id);
  xhr.send(data);
}

module.exports = {
  submit_rate,
}